import React, {useState} from 'react';
import './Gallery.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import Card from "../../card/Card";
import FullView from "./FullView";
import ButtonCloseMainPopup from "../ButtonCloseMainPopup";
import ComicsViewer from "./ComicsViewer";


function GalleryComponent() {

    const {user, cards} = useTypedSelector(state => state.auth);

    const [cardIdFullView, setCardIdFullView] = useState(0);
    const [visibleFullView, setVisibleFullView] = useState(false);

    const showFullSize = function (cardId: any) {

        setCardIdFullView(cardId);
        setVisibleFullView(true);
    }

    // @ts-ignore
    return (
        <div className="main-popup-container">
            <ButtonCloseMainPopup/>
            <FullView visible={visibleFullView} cardId={cardIdFullView} setVisibleFullView={setVisibleFullView}/>

            <div className={'offersTitle'}>
                <div className={'offersTitleText'}>Gallery</div>
            </div>


            <div className="research-card-slider">
                <Swiper
                    modules={[Navigation]}
                    spaceBetween={1}
                    loop={false}
                    threshold={10}
                    touchRatio={1}
                    touchStartPreventDefault={true}
                    navigation={{
                        prevEl: '.swiper-button-prev-res',
                        nextEl: '.swiper-button-next-res',
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 6, // phones, tablets, small laptops
                        },
                        2200: {
                            slidesPerView: 8, // full HD+ desktops
                        },
                    }}
                >

                    {Object.keys(user.library.cards).map((item, index) => {
                        let cardId = user.library.cards[item].id;

                        return <SwiperSlide key={index}>
                            <div className={'gallerySwiperSlideContainer'}
                                 onClick={() => {
                                     showFullSize(cardId)
                                 }}
                            >

                                <Card card={cards[cardId]}/>

                            </div>

                        </SwiperSlide>;
                    })}

                </Swiper>
                <div className="swiper-button-prev swiper-button-prev-res"></div>
                <div className="swiper-button-next swiper-button-next-res"></div>
            </div>

            <ComicsViewer/>

        </div>
    );
}

export default GalleryComponent;